module.exports = __webpack_public_path__ + "5506d4f49f71ee896b6531db574a7113.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1/public/team/CarolinaMastretta.png
// module id = 462
// module chunks = 0